// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICensusRecordDto } from './ICensusRecordDto';
import {
    ICensusRecordDtoFromJSON,
    ICensusRecordDtoFromJSONTyped,
    ICensusRecordDtoToJSON,
    ICensusRecordDtoToJSONTyped,
} from './ICensusRecordDto';

/**
 * 
 * @export
 * @interface ICensusRequestDto
 */
export interface ICensusRequestDto {
    /**
     * 
     * @type {number}
     * @memberof ICensusRequestDto
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof ICensusRequestDto
     */
    received_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICensusRequestDto
     */
    status?: ICensusRequestDtoStatusEnum;
    /**
     * 
     * @type {Array<ICensusRecordDto>}
     * @memberof ICensusRequestDto
     */
    records?: Array<ICensusRecordDto>;
}

/**
* @export
* @enum {string}
*/
export enum ICensusRequestDtoStatusEnum {
    RECEIVED = 'RECEIVED',
    PENDING_RESULT = 'PENDING_RESULT',
    RESULT_AVAILABLE = 'RESULT_AVAILABLE'
}


/**
 * Check if a given object implements the ICensusRequestDto interface.
 */
export function instanceOfICensusRequestDto(value: object): value is ICensusRequestDto {
    return true;
}

export function ICensusRequestDtoFromJSON(json: any): ICensusRequestDto {
    return ICensusRequestDtoFromJSONTyped(json, false);
}

export function ICensusRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICensusRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'received_at': json['receivedAt'] == null ? undefined : (new Date(json['receivedAt'])),
        'status': json['status'] == null ? undefined : json['status'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(ICensusRecordDtoFromJSON)),
    };
}

export function ICensusRequestDtoToJSON(json: any): ICensusRequestDto {
    return ICensusRequestDtoToJSONTyped(json, false);
}

export function ICensusRequestDtoToJSONTyped(value?: ICensusRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'receivedAt': value['received_at'] == null ? undefined : ((value['received_at']).toISOString()),
        'status': value['status'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(ICensusRecordDtoToJSON)),
    };
}

